const textarea = document.getElementsByTagName('textarea');
const textareaList = Array.prototype.slice.call(textarea);

function onInput() {
  this.style.height = '34px';
  this.style.height = `${this.scrollHeight}px`;
}

textareaList.forEach((element) => {
  element.setAttribute('style', `height:${element.scrollHeight}px;overflow-y:hidden;`);
  element.addEventListener('input', onInput, false);
});
